interface ExceptionItem {
    key: string;
    title: string;
    requiresInput?: boolean;
    inputLabel?: string;
    mainHeadingTitle?: string;
}

export const exceptionList: ExceptionItem[] = [
    {
        key: "PFT",
        title: "Proctor Finished Test"
    },
    {
        key: "SAD",
        title: "No of Suspicious Activity Detected",
        requiresInput: true,
        inputLabel: "Enter No of Count"
    },
    {
        key: "CTP",
        title: "No of Test Pauses",
        requiresInput: true,
        inputLabel: "Enter No of Count"
    },
    {
        key: "BTE",
        title: "Browsing Tolerance Exceeded",
        mainHeadingTitle: "Test Events"
    },
    {
        key: "UNAP",
        title: "Away from Test Window",
        requiresInput: true,
        inputLabel: "Enter No of Count"
    },
    {
        key: "CAFTWD",
        title: "Duration of Away from Test Window",
        requiresInput: true,
        inputLabel: "Enter in Sec"
    },
    {
        key: "ID",
        title: "No of Internet Disconnection"
    },
    {
        key: "IDD",
        title: "Duration of Internet Disconnection",
        requiresInput: true,
        inputLabel: "Enter in Sec"
    },
    {
        key: "CTR",
        title: "No of Test Resume",
        requiresInput: true,
        inputLabel: "Enter No of Count"
    },
    {
        key: "IPC",
        title: "Candidate IP change"
    },
    {
        key: "MSD",
        title: "Multiple Screen Detected. Test Finished"
    },
    {
        key: "CSW",
        title: "Camera Stopped Working"
    },
    {
        key: "SSS",
        title: "Screen Share Stopped Working"
    },
    {
        key: "MMBPC",
        title: "Mic Mute Tolerance exceeded"
    },
    {
        key: "NSD",
        title: "No of Speakers Detected",
        mainHeadingTitle: "Audio Proctoring Flags",
        requiresInput: true,
        inputLabel: "Enter No of Count"
    },
    {
        key: "TSD",
        title: "Total Speech Duration",
        requiresInput: true,
        inputLabel: "Enter in Sec"
    },
    {
        key: "CMS",
        title: "Microphone Stopped Working"
    },
    {
        key: "CNP",
        title: "Candidate Not Present",
        mainHeadingTitle: "Visual Proctoring Flags",
        requiresInput: true,
        inputLabel: "Enter No of Count"
    },
    {
        key: "FND",
        title: "Candidate Face Not Visible",
        requiresInput: true,
        inputLabel: "Enter No of Count"
    },
    {
        key: "MFD",
        title: "Another Person There",
        requiresInput: true,
        inputLabel: "Enter No of Count"
    },
    {
        key: "MPD",
        title: "Mobile Phone Detected",
        requiresInput: true,
        inputLabel: "Enter No of Count"
    },
    {
        key: "CLA",
        title: "Candidate Looking Away From Screen",
        requiresInput: true,
        inputLabel: "Enter No of Count"
    },
    {
        key: "FPV",
        title: "Candidate Face Partially Visible",
        requiresInput: true,
        inputLabel: "Enter No of Count"
    },
    {
        key: "CID",
        title: "Candidate Impersonation Suspected",
        requiresInput: true,
        inputLabel: "Enter No of Count"
    },
    {
        key: "CCR",
        title: "Total Red Visual Proctoring Flags (FNV+CNP+APT+MPD+CIS +CLAS+CFPV) + Away from Test Window flag",
        mainHeadingTitle: "Flag Totals (Red , Yellow, Away From Test Window)",
        requiresInput: true,
        inputLabel: "Enter No of Count"
    },
    {
        key: "CCRY",
        title: "Total Red (FNV+CNP+APT+MPD+CIS) +Yellow Visual Proctoring Flags (CLAS+CFPV) + Away from Test Window flag",
        requiresInput: true,
        inputLabel: "Enter No of Count"
    }
]